import { render, staticRenderFns } from "./userMessage.vue?vue&type=template&id=4784b6a9&scoped=true"
import script from "./userMessage.vue?vue&type=script&lang=js"
export * from "./userMessage.vue?vue&type=script&lang=js"
import style0 from "./userMessage.vue?vue&type=style&index=0&id=4784b6a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784b6a9",
  null
  
)

export default component.exports